import { BundleOption } from '../api/shopify/types';

const getRelevantBundle = (bundles: Array<BundleOption>, sku: number, group: number): BundleOption | undefined => {
  if (!bundles?.length) return;

  return (
    bundles.find(bundle => bundle.productSkus.includes(sku)) ||
    bundles.find(bundle => bundle.productGroups.includes(group))
  );
};

export const fetchCurrentBundleOffering = (
  sku: number | string,
  group: number | string,
  optimizelyBundles: Array<BundleOption>,
  shopifyBundles: Array<BundleOption>
): BundleOption | undefined => {
  const productSku = parseInt(sku.toString());
  const productGroup = parseInt(group.toString());
  const optimizelyBundle = getRelevantBundle(optimizelyBundles, productSku, productGroup);
  const shopifyBundle = getRelevantBundle(shopifyBundles, productSku, productGroup);
  return optimizelyBundle ? optimizelyBundle : shopifyBundle;
};
